import React, { useMemo } from "react";
import { CustomModal, SpinnerLoader } from "@services/ui-components";
import { useTranslation } from "react-i18next";
import { ButtonProps } from "@services/ui-components/src/Modal/CustomModal";

interface ConfirmDeleteVacationModalProps {
    show: boolean;
    vacationId: number | null;
    onCancel: () => void;
    onConfirm: (vacationId: number) => void | Promise<void>;
    isDeleting?: boolean;
}

const ConfirmDeleteVacationModal: React.FC<ConfirmDeleteVacationModalProps> = ({
    show,
    vacationId,
    onCancel,
    onConfirm,
    isDeleting = false,
}) => {
    const { t } = useTranslation();
    const buttons: ButtonProps[] = useMemo(() => {
        return [
            {
                text: t("Cancel"),
                variant: "outline-primary",
                className: "w-100",
                onClick: onCancel,
                disabled: isDeleting,
                type: "button",
            },
            {
                text: isDeleting ? <SpinnerLoader variant="light" loadingText={t("Delete")} /> : t("Delete"),
                variant: "primary",
                className: "w-100",
                onClick: () => {
                    if (!vacationId) return;
                    onConfirm(vacationId);
                },
                disabled: isDeleting || !vacationId,
                type: "button",
            },
        ];
    }, [isDeleting, onCancel, onConfirm, vacationId, t]);

    return (
        <CustomModal
            show={show}
            handleClose={onCancel}
            title={t("Vacation deletion")}
            body={t("Are you sure you want to delete the vacation?")}
            headerAlignment="center"
            bodyAlignment="center"
            buttons={buttons}
            backdrop="static"
            keyboard={false}
        />
    );
};

export default ConfirmDeleteVacationModal;
